import { Box, Popover } from "@mui/material";
import { ReactElement, useEffect, useState } from "react";

interface props {
  layout: ReactElement;
  anchorEl: HTMLButtonElement | null;
  onClose: () => void;
}

export function CustomPopoverView(props: props) {

  const handleClose = () => {
    props.onClose()
  };

  const open = Boolean(props.anchorEl);
  const id = open ? "popover" : undefined;


  return (
    <Box>
      <Popover
        id={id}
        open={open}
        anchorEl={props.anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'center',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        PaperProps={{ sx: { borderRadius: 6 } }}
        elevation={12}
      >
        {props.layout}
      </Popover>
    </Box>
  );
}
